import {Organization} from "@App/types";

/**
 * Check if the default sorting for the garage list is set to smallest distance
 * @param organization - The organization to check
 * @constructor
 */
export const DefaultSortingIsSmallestDistance = (organization: Organization): boolean => organization.settings.garage_list.default_sorting === 'smallest_distance'
